import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';
import lazyLoad from './script/lazyLoad';
import sliders from './script/slider';
import mobMenu from './script/mobMenu';
import readMore from './script/readmore';
import accordian from './script/accordian';
import titleResize from './script/titleResize';
import showHide from './script/showHide';
import buyingQty from './script/buyingQty';
import headerHoverPopups from './script/headerHoverPopups';
import stickyHeader from './script/stickyHeader';
import showHideItems from './script/showHideItems';
import scrollCart from './script/cartLine';
import './script/popupCalls';
addEvent();
appHeight();

lazyLoad.init();
mobMenu.init();
readMore.init();
accordian.init();
// titleResize.init();
showHide.init();
buyingQty.init();
sliders.init();
headerHoverPopups.init();
stickyHeader.init();
showHideItems.init();
scrollCart.init();